import { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'
// import ItemTypes from '../../constants/dndItemTypes'

const itemSource = {
	beginDrag(props) {
		return {
			// id: props.id,
			listId: props.listId,
			index: props.index,
		}
	},

	endDrag(props) {
		if(props.onEndDrag) {
			props.onEndDrag()
		}
	}
}

const itemTarget = {
	hover(props, monitor, component) {
		const dragIndex = monitor.getItem().index
		const sourceListId = monitor.getItem().listId
        const hoverIndex = props.index

		// Don't replace items with themselves
		if (dragIndex === hoverIndex) {
			return
		}

		// Determine rectangle on screen
		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

		// Get vertical middle
		const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

		// Determine mouse position
		const clientOffset = monitor.getClientOffset()

		// Get pixels to the top
		const hoverClientY = clientOffset.y - hoverBoundingRect.top

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
			return
		}

		// Dragging upwards
		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return
		}

		if(props.listId === sourceListId) {
			// Time to actually perform the action
			props.moveItem(dragIndex, hoverIndex)

			// Note: we're mutating the monitor item here!
			// Generally it's better to avoid mutations,
			// but it's good here for the sake of performance
			// to avoid expensive index searches.
			monitor.getItem().index = hoverIndex
		}
	},
}

@DropTarget(props => (props.dndType), itemTarget, (connect) => ({
	connectDropTarget: connect.dropTarget()
}))
@DragSource(props => (props.dndType), itemSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	isDragging: monitor.isDragging(),
}))

class SortableWrapperContainer extends Component {
	render() {
		const { children, connectDragSource, connectDropTarget, dndType, isDragging } = this.props

		return connectDragSource(
			connectDropTarget(
				<div className={isDragging ? 'is-sorting' : ''}>
					{children}
				</div>
            )
		)
	}
}

export default SortableWrapperContainer